// USAGE:
/* ELEMENT, CLASS TO APPEND, IDENTIFIER
/* _$(`<span class="close"></span>`, '.article-body', 1) */

import lib from "./lib";

const _$ = {
  create: (str, qs, identifier) => {
    // Init DOM Parser
    let doc = new DOMParser().parseFromString(str, "text/html");
    let elem = lib.qs(qs);
    let e = lib.qs(['[_s="' + identifier + '"]']);

    // if (e.getAttribute("_s") === 1) {
    //   e.remove(); // If node exists, remove it
    // }

    // Create New Node
    elem.insertAdjacentHTML("beforeend", doc.body.innerHTML);
    elem.children[elem.children.length - 1].setAttribute("_s", identifier);
    elem.children[elem.children.length - 1].setAttribute(
      "uuid",
      Math.floor(Math.random() * 9999999999)
    );
    return elem.children[elem.children.length - 1];
  },
  delete: () => {},
};

export { _$ };
